var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmployee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4787_39014)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87741 1.49219C3.30505 1.49219 2.84105 1.9399 2.84105 2.49219V13.4922C2.84105 14.0445 3.30505 14.4922 3.87741 14.4922H11.132C11.7043 14.4922 12.1683 14.0445 12.1683 13.4922V2.49219C12.1683 1.9399 11.7043 1.49219 11.132 1.49219H3.87741ZM1.80469 2.49219C1.80469 1.38762 2.73268 0.492188 3.87741 0.492188H11.132C12.2767 0.492188 13.2047 1.38762 13.2047 2.49219V13.4922C13.2047 14.5968 12.2767 15.4922 11.132 15.4922H3.87741C2.73268 15.4922 1.80469 14.5968 1.80469 13.4922V2.49219Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94922 2.56412C5.94922 2.27845 6.12322 2.04688 6.33786 2.04688H8.66967C8.88431 2.04688 9.05831 2.27845 9.05831 2.56412C9.05831 2.84978 8.88431 3.08136 8.66967 3.08136H6.33786C6.12322 3.08136 5.94922 2.84978 5.94922 2.56412Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83858 6.73914C8.66752 6.56191 8.46032 6.42133 8.23022 6.32638C8.00013 6.23142 7.7522 6.18418 7.50227 6.18768C6.97645 6.18768 6.50095 6.38208 6.16324 6.73562C5.82554 7.08915 5.65555 7.57846 5.69454 8.10215C5.77205 9.13718 6.58299 9.9787 7.50227 9.9787C8.42155 9.9787 9.23113 9.13718 9.30955 8.10303C9.34944 7.58375 9.18173 7.09929 8.83858 6.73914ZM10.5706 13.9461H4.43393C4.35404 13.9473 4.27485 13.9315 4.20193 13.8997C4.12901 13.868 4.06415 13.821 4.01191 13.7622C3.95527 13.6963 3.91462 13.6187 3.89297 13.5354C3.87131 13.4521 3.8692 13.3651 3.8868 13.2809C4.03412 12.5068 4.49331 11.8566 5.21495 11.4003C5.85591 10.9952 6.66821 10.7722 7.50227 10.7722C8.33633 10.7722 9.14863 10.9952 9.78959 11.4003C10.5112 11.8566 10.9704 12.5068 11.1177 13.2809C11.1353 13.3651 11.1332 13.4521 11.1116 13.5354C11.0899 13.6187 11.0493 13.6963 10.9926 13.7622C10.9404 13.821 10.8755 13.868 10.8026 13.8997C10.7297 13.9315 10.6505 13.9473 10.5706 13.9461Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4787_39014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.00390625 0.492188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmployee);
export default __webpack_public_path__ + "static/media/icon-employee.e8bf9723753639ac5f772d80b5059900.svg";
export { ForwardRef as ReactComponent };